import "./GVTColorSymbol.css";

export const GVTColorSymbol = (props: {
	children: string;
	class?: string;
	/**
	 * Surface the glyph sits on: `standard` follows the app's theme, `inverse`
	 * is for a surface built from the --colour-inverse-* tokens, which runs dark
	 * under a light theme and light under a dark one.
	 */
	theme?: "standard" | "inverse";
}) => {
	return (
		<span
			class={`gvt-color-symbol ${props.class ?? ""}`}
			classList={{ "gvt-color-symbol--inverse": props.theme === "inverse" }}
		>
			{props.children}
		</span>
	);
};
